import yup from 'yup'

const passwordRex = new RegExp('^(?=.*\\d)(?=.*[!@#$%^&*\\.\\,\\:])(?=.*[a-z])(?=.*[A-Z]).{8,32}$');

const schema = yup
  .object()
  .shape({
    newPassword: yup.string().matches(passwordRex, 'Invalid format').required('Required'),
    confirmPassword: yup.string().matches(passwordRex, 'Invalid format').required('Please confirm your password'),
  })

export default schema



// WEBPACK FOOTER //
// ./src/forms/ResetPassword/schema.js